<app-header></app-header>
<div class="title"></div>
<div class="container margin-top-70">
  <div class="row">
    <div class="col-md-6 mt-6 mx-auto">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Format
            </td>
            <td colspan="2">
              <app-drop-down-single-select
                [DropDownOptions]="listFormat"
                (typeSelectedChanged)="updateSelectedType($event)"
                [name]="'format'"
              ></app-drop-down-single-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-6 mt-6 mx-auto">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Published Date is Between
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left date-input-6r'"
                type="startDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left date-input-6r'"
                type="endDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div>
  <div class="container" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Product Id</th>
          <th scope="col">Title</th>
          <th scope="col">Status</th>
          <th scope="col">CDE</th>
          <th scope="col">PC</th>
          <th scope="col">Cancelled Date</th>
          <th scope="col">ISBN-13P</th>
          <th scope="col">ISBN-10P</th>
          <th scope="col">ISBN-13E</th>
          <th scope="col">ISBN-10E</th>
          <th scope="col">Brand</th>
          <th scope="col">Body Type</th>
          <th scope="col">Author Bio</th>
          <th scope="col">Published Date</th>
          <th scope="col">Price</th>
          <th scope="col">Page Count</th>
          <th scope="col">Publisher</th>
          <th scope="col">Commercial Priority</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.part_number}}</td>
          <td>{{product.name}}</td>
          <td>{{product.status}}</td>
          <td>{{product.CDE}}</td>
          <td>{{product.PC}}</td>
          <td>{{product.cancelled_date}}</td>
          <td>{{product.isbn_13}}</td>
          <td>{{product.isbn_10}}</td>
          <td>{{product.isbn_13e}}</td>
          <td>{{product.isbn_10e}}</td>
          <td>{{product.brand}}</td>
          <td>{{product.book_type}}</td>
          <td><div [innerHTML]="product.author_bio"></div></td>
          <!-- <td>{{product.author_bio}}</td> -->
          <td>{{product.publishing_date}}</td>
          <td>{{product.price | number: '1.2-2'}}</td>
          <td>{{product.final_length_book}}</td>
          <td>{{product.Publisher}}</td>
          <td>{{product.commercial_priority}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
<ngb-toast
  class="toast-container position-fixed top-0 end-0 p-3"
  style="z-index: 1200; background-color: #871919; color: aliceblue;"
  *ngIf="successToastShow"
  [autohide]="true"
  (hidden)="successToastShow=false"
>
  Please select both start and end dates to get the data!
</ngb-toast>
